"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _helpers = require("../../helpers");
var _helpers2 = require("../helpers");
var _FormulaMember = _interopRequireDefault(require("../../FormulaMember"));
var _errors = _interopRequireDefault(require("../../../errors"));
var _Placeholder = _interopRequireDefault(require("./Placeholder"));
var _FormulaBody = _interopRequireDefault(require("../FormulaBody.style"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var FixCosts = function FixCosts(props) {
  var disabled = props.disabled,
    errors = props.errors,
    labels = props.labels,
    placeholderLabel = props.placeholderLabel,
    getFormulaOperandValues = props.getFormulaOperandValues,
    rule = props.rule,
    ruleIndex = props.ruleIndex,
    formulaOperators = props.formulaOperators,
    ruleChange = props.ruleChange,
    formulaOtherProps = props.formulaOtherProps;
  var errorMessage = (0, _helpers2.getErrorMessage)(errors);
  var hasError = !R.isEmpty(errorMessage);
  var withPaddingError = hasError ? false : R.keys(R.path(['formula'], errors)).length > 0;
  return /*#__PURE__*/_react["default"].createElement(_FormulaBody["default"], {
    disabled: disabled,
    withPaddingError: withPaddingError,
    className: "formula-container ".concat(hasError ? 'formula-empty-error-container' : '')
  }, R.length(R.prop('formula', rule)) ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "formula-active-view"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "formula-active-wrapper ".concat(withPaddingError ? 'error' : '')
  }, rule.formula.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(_FormulaMember["default"], _extends({
      labels: labels,
      errors: R.prop('formula', errors),
      disabled: disabled,
      formulaOperators: formulaOperators,
      member: item,
      key: item.key,
      elementKey: item.key,
      keysPath: [index],
      ruleIndex: ruleIndex,
      actions: _objectSpread(_objectSpread({}, (0, _helpers.getFormulaActions)('formula', rule.formula, ruleChange)), {}, {
        getFormulaOperandValues: getFormulaOperandValues
      })
    }, formulaOtherProps));
  }))) : /*#__PURE__*/_react["default"].createElement(_Placeholder["default"], {
    label: placeholderLabel,
    disabled: disabled,
    createInitialFormula: R.compose(function (formula) {
      return ruleChange('formula', formula);
    }, _helpers.createInitialFormula)
  }), hasError && /*#__PURE__*/_react["default"].createElement(_errors["default"], {
    className: "formula-empty-error-label",
    message: errorMessage
  }));
};
FixCosts.defaultProps = {
  errors: {},
  disabled: false,
  formulaOtherProps: {},
  formulaOperators: []
};
FixCosts.propTypes = {
  disabled: _propTypes["default"].bool,
  ruleIndex: _propTypes["default"].number.isRequired,
  errors: _propTypes["default"].shape({
    formula: _propTypes["default"].shape({
      generic: _propTypes["default"].string
    })
  }),
  formulaOperators: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    displayName: _propTypes["default"].string,
    name: _propTypes["default"].string
  })),
  labels: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  placeholderLabel: _propTypes["default"].string.isRequired,
  formulaOtherProps: _propTypes["default"].shape({}),
  rule: _propTypes["default"].shape({
    formula: _propTypes["default"].arrayOf(_propTypes["default"].shape({}))
  }).isRequired,
  ruleChange: _propTypes["default"].func.isRequired,
  getFormulaOperandValues: _propTypes["default"].func.isRequired,
  setHasChanges: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = FixCosts;